import { useMediaQuery } from '@material-ui/core'
import { useAppTheme } from '../themes'
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'


export const useBreakpoint = (): Breakpoint => {
  const appTheme = useAppTheme()
  const keys: readonly Breakpoint[] = [...appTheme.breakpoints.keys]
  return keys.reduce((output: Breakpoint, key: Breakpoint) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const matches = useMediaQuery(appTheme.breakpoints.up(key))
    return matches ? key : output
  }, 'xs')
}
